import { useState } from 'react';
import useIsSeoFromDocumentReferrer from '@alltrails/networking/hooks/useIsSeoFromDocumentReferrer';
import isSessionSeoOrViralityTraffic from '@/utils/isSessionSeoOrViralityTraffic';

// On the first page load of a session, `sessionAttribution` has not been captured yet
// (it is written in an effect by useCaptureSessionAttribution), so we read the `sh`
// virality param directly from the URL as a synchronous fallback to avoid a false -> true flip.
const hasViralityUrlParam = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!new URLSearchParams(window.location.search).get('sh');
};

// Client-side SEO/virality traffic detection. Independent of any experiment.
// Frozen on mount so the value is stable and correct from the first render. Otherwise the
// asynchronously-captured sessionAttribution causes a false -> true flip that double-fires exposures.
const useIsSeoOrViralityTraffic = () => {
  const isSeoFromDocumentReferrer = useIsSeoFromDocumentReferrer();
  const [isSeoOrViralityTraffic] = useState(() => isSessionSeoOrViralityTraffic() || isSeoFromDocumentReferrer || hasViralityUrlParam());
  return isSeoOrViralityTraffic;
};

export default useIsSeoOrViralityTraffic;
